import React from 'react';
import fr from 'facet-rest';
import { pickComponentAndProps } from 'Helpers/Affordances';
import useUserContext from 'Context/UserContext';
import ClientExperience from './ClientExperienceRoot';

const ClientExperiencePicker = () => {
  const { userResource } = useUserContext();
  const { component: ClientExperienceComponent, props: componentProps } = pickComponentAndProps(userResource, {
    [fr.relationships.clientExperience.name]: [ClientExperience, {}],
    [fr.relationships.default.name]: [() => null, {}],
  });

  return (
    <ClientExperienceComponent {...componentProps} />
  );
};

export default ClientExperiencePicker;
